import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SharedService } from '../../shared/shared.service';
import { ReportsService } from './reports.service';
import moment from 'moment';

@Component({
    selector: 'app-reports',
    templateUrl: './reports.component.html',
    styleUrls: ['./reports.component.scss'],
    standalone: false
})
export class ReportsComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'start_date', 'report', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);
  today: Date = new Date();
  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  isLoading: Subject<boolean> = new Subject<boolean>();
  dateRange: Date[] | null = null;
  reportsMaster: any = [
    // { "id": 24, "name": "All Leads" },
    // { "id": 25, "name": "DD Leads" },
    { "id": 26, "name": "Enquiry Report(Advisable for 30 days)" },
    { "id": 27, "name": "DD Report (Advisable for 30 days)" }
  ]

  bsConfig = {
    dateInputFormat: 'DD-MM-YYYY', // Set desired format
    showWeekNumbers: false,
    isAnimated: true
  };
  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private reportsService: ReportsService) {
  }

  public submitted: boolean = false;
  roleId: any = null;

  ngOnInit() {
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
      this.isActiveOutlet = filterObject.isActiveOutlet ? filterObject.isActiveOutlet : false;
    }
    this.getList();
    if (sessionStorage.getItem('loginResponse')) {
      const loginResponse = JSON.parse(sessionStorage.getItem('loginResponse') || '{}');
      if (loginResponse && loginResponse.data) {
        this.roleId = loginResponse.data?.user?.role_id;
        if (this.roleId == 10) {
          this.reportsMaster = [
            { "id": 26, "name": "Enquiry Report(Advisable for 30 days)" },
            { "id": 27, "name": "DD Report (Advisable for 30 days)" }
          ]
        } else {
          this.reportsMaster = [
            // { "id": 24, "name": "All Leads" },
            // { "id": 25, "name": "DD Leads" },
            { "id": 26, "name": "Enquiry Report(Advisable for 30 days)" },
            { "id": 27, "name": "DD Report (Advisable for 30 days)" }
          ]
        }
      }
    }
  }


  download() {
  }


  selectedReportId: any = '';
  getReport() {
    console.log("selectedReportId:", this.selectedReportId, "dateRange: ", this.dateRange);
    if (!this.selectedReportId && !this.dateRange) {
      this.toastr.error('Please select a report and date range!');
      return;
    } else if (!this.selectedReportId) {
      this.toastr.error('Please select a report!');
      return;
    } else if (!this.dateRange) {
      this.toastr.error('Please select date range!');
      return;
    } else {
      let reqObject = {
        report: parseInt(this.selectedReportId),
        from: moment(this.dateRange[0]).format('YYYY-MM-DD'),
        to: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        is_outlet_all: this.isActiveOutlet ? 2 : 1
      }
      console.log("request:", reqObject)
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.reportsService.generateReport(reqObject).subscribe((response: any) => {
        let responseData = response.body
        if (responseData.responseCode == 200) {
          let url: any = responseData.data.download_url
          // Trigger the download
          if (url) {
            const link = document.createElement('a');
            link.href = url;
            link.download = ''; // Optional: Specify a default filename if needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success('Report generated successfully! The file will download automatically, please wait...');
          this.getList();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
      });
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.reportsService.getReportsList().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  isActiveOutlet: boolean = false;
  outletToggle(event: any) {
    this.isActiveOutlet = event.checked;
    let filterObject: any = {}
    if (sessionStorage.getItem('filterObject')) {
      filterObject = JSON.parse(sessionStorage.getItem('filterObject') || '{}');
    }
    filterObject.isActiveOutlet = this.isActiveOutlet;
    sessionStorage.setItem('filterObject', JSON.stringify(filterObject));
  }

  onDateRangeChange(range: any) {
    if (range && range.length === 2) {
      const [start, end] = range;
      console.log("range: ", range)
      // Check if both dates are in the same month & year
      const isSameMonth = start.getMonth() === end.getMonth() && start.getFullYear() === end.getFullYear();

      if (!isSameMonth) {
        // Invalidate selection if month differs
        this.toastr.error("Please select a date range within the same month.")
        setTimeout(() => {
          this.dateRange = [];
        }, 200)
      }
    }
  }
}
